"use strict";
/* eslint-disable complexity */
/* eslint-disable no-console */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbCCDevAuthenticator = void 0;
const web_ui_security_1 = require("@gruposantander/web-ui-security");
const types_1 = require("../../../security/session/cc/types");
//TODO Authenticator only for model or not??
class MbCCDevAuthenticator extends web_ui_security_1.BaseAuthenticator {
    constructor(session, xhr, helper) {
        super(session);
        this.agentToken = '';
        this.agentRefreshToken = '';
        this.doLogin = async (data) => {
            const loginResult = await this.helper.requestLogin(data);
            return {
                ...loginResult,
                agentToken: this.agentToken,
                agentRefreshToken: this.agentRefreshToken,
                username: data.username,
                entrypoint: types_1.EntrypointType.CCDev,
            };
        };
        this.doLogout = async () => {
            const accessToken = this.getSession().getData()?.accessToken;
            await this.xhr.POST(`${window.MIDDLEWARE_BASE_HOST}/mb-api-auth/authentication/logout`, { accessToken });
        };
        this.requestAgentData = async (params) => {
            const data = await this.helper.requestAgentData(params);
            this.agentToken = data.accessToken;
            this.agentRefreshToken = data.refreshToken;
            return data;
        };
        this.requestInteractionId = (param) => {
            return this.helper.requestInteractionId(param);
        };
        this.requestPasswordPosition = (param) => {
            return this.helper.requestPasswordPosition(param);
        };
        this.xhr = xhr;
        this.helper = helper;
    }
}
exports.MbCCDevAuthenticator = MbCCDevAuthenticator;
//# sourceMappingURL=index.js.map